import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ErrorModalComponent } from '../../../components/tools/modals/error-modal/error-modal.component';
import { SubcategoriasGastosService } from '../../../services/subcategorias-gastos.service';
import { HelpersService } from '../../../services/tools/helpers.service';

declare var $;
@Component({
  selector: 'app-subcategorias-gastos-modal',
  templateUrl: './subcategorias-gastos-modal.component.html',
  styleUrls: ['./subcategorias-gastos-modal.component.scss']
})
export class SubcategoriasGastosModalComponent implements OnInit {
 
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
 
  selected: any = {};
  errors: any = {};
  processing: boolean = false;
  isUpdate: boolean = false;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor(
      private subcategoriasGastosService: SubcategoriasGastosService,
      private helperService: HelpersService,
    ) {
    
  }

  ngOnInit() {
    this.selected = this.subcategoriasGastosService.getDefaultSchedule();
  }


  reset() {
    this.selected = {};
    this.isUpdate = false;
    this.errors = {};
  }

  close(){
    $('#subcategorias-gastos-modal').modal('hide');
  }

  open(subcategoria) {
    this.reset();
    this.selected = subcategoria;
    if(subcategoria.id)
    {
      this.isUpdate = true;
    }
    $('#subcategorias-gastos-modal').modal('show');
  }

  onKeyup($event) {
    if($event.key == 'Enter') {
      this.accept();
    }
  }

  accept() {
    this.errors = [];

    this.errors = this.subcategoriasGastosService.validate(this.selected);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    
    if(this.isUpdate)
      this.update();
    else
      this.create();
    
  }

  create(){
    this.subcategoriasGastosService.create(this.selected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        console.log(response.json())
        if (respuesta.success) {
          this.helperService.notification('Subcategoría guardada', 'Se ha creado exitosamente la subcategorias: ' + this.selected.nombre, 'success');
          this.goToCallback.emit('reload'); // when we emit, we reload the liquidation list
          this.close(); 
        }
      }, error => {
        this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  update() {
    this.subcategoriasGastosService.update(this.selected, this.selected.idSubcategoriasGastos)
      .subscribe(response => {
        this.processing = false;
        console.log(response.json())
        if (response.json().success) {
          this.helperService.notification('Subcategoría actualizada', 'Se ha actualizado exitosamente la subcategoría: ' + this.selected.nombre, 'success');
          this.goToCallback.emit('reload'); 
          this.close();
        }
      }, error => {
        this.processing = false;

        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/categorias-gastos/subcategorias-gastos-modal/subcategorias-gastos-modal.component.ts